import { createReducer } from 'redux-act';
import { AuthMethod } from 'config/constants';
import { ssoInitCompleted, ssoLoginSuccess, ssoLogoutSuccess, ssoSyncProfile } from './actions';

export const initialState = {
  memberId: null,
  title: null,
  firstName: null,
  lastName: null,
  pointsBalance: null,
  membershipTier: null,
  token: null,
  isAuthenticated: false,
  hasInitializedSSO: false,
};

export const reducerBranches = {
  [ssoInitCompleted]: (state, payload) => {
    const { authMethod: authMethodRequiredForBooking, hasFetchedBookingAuthMethod: existingHasFetchedAuth } = state;

    return {
      ...state,
      ssoUser: {
        ...payload,
        hasInitializedSSO: true,
      },
      hasFetchedBookingAuthMethod: authMethodRequiredForBooking === AuthMethod.WIDGET || existingHasFetchedAuth,
    };
  },
  [ssoLoginSuccess]: (state, payload) => ({
    ...state,
    ssoUser: {
      ...payload,
      hasInitializedSSO: state.ssoUser.hasInitializedSSO,
    },
  }),
  [ssoLogoutSuccess]: (state) => ({
    ...state,
    ssoUser: {
      ...initialState,
      hasInitializedSSO: state.ssoUser.hasInitializedSSO,
    },
  }),
  [ssoSyncProfile]: (state, payload) => ({
    ...state,
    ssoUser: {
      ...payload,
      hasInitializedSSO: state.ssoUser.hasInitializedSSO,
    },
  }),
};

const ssoAuthenticationReducer = createReducer(reducerBranches, { ssoUser: initialState });

export default ssoAuthenticationReducer;
